import imageServiceUrl from '../../image/instance'

const getProductImageConfig = (productId) => {
	return imageServiceUrl.get(`/images/products/${productId}`)
}

export default getProductImageConfig
